import axios from 'axios';
import { baseUrl } from '../../utils/constants';

const client = axios.create({
  baseURL: baseUrl
  // headers: {
  //     Authorization: `Mombez ${sessionStorage.getItem('token')}`
  // }
});

export const request = ({ ...options }) => {
  client.defaults.headers.common.Authorization = `Mombez ${sessionStorage.getItem('token')}`;
  const onSuccess = (response) => response;
  const onError = (error) => {
    console.log('error in axios', error);
    return error;
  };

  return client(options).then(onSuccess).catch(onError);
};
